export default "__VITE_ASSET__S3HVzOdu__"